const FILE_STATUS = {
  WAIT: 1,
  UPLOADING: 2,
  UPLOADED: 3,
  ERROR: 4,
  PRE_UPLOADED: 5
};

export default FILE_STATUS;
